import React from 'react';
export function ProblemSection() {
  return <section className="py-8 md:py-12 border-b border-gray-200" data-id="element-103">
      <h2 className="text-xl md:text-3xl font-bold text-center mb-6 md:mb-8" data-id="element-104">
        If You're Like Most Adults Over 40...
      </h2>
      <p className="text-base md:text-lg text-center mb-6 md:mb-8" data-id="element-105">
        You know these struggles:
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-10" data-id="element-106">
        <div className="bg-gray-50 p-4 md:p-6 rounded-lg" data-id="element-107">
          <div className="text-xl md:text-2xl mb-2" data-id="element-108">❄️ Always Cold</div>
          <p className="text-sm md:text-base" data-id="element-109">
            Your hands and feet feel like ice, even indoors
          </p>
        </div>
        <div className="bg-gray-50 p-4 md:p-6 rounded-lg" data-id="element-110">
          <div className="text-xl md:text-2xl mb-2" data-id="element-111">😴 Low Energy</div>
          <p className="text-sm md:text-base" data-id="element-112">
            You're tired by 2 PM and struggle with daily tasks
          </p>
        </div>
        <div className="bg-gray-50 p-4 md:p-6 rounded-lg" data-id="element-113">
          <div className="text-xl md:text-2xl mb-2" data-id="element-114">💔 Heart Concerns</div>
          <p className="text-sm md:text-base" data-id="element-115">
            Family history keeps you worried about circulation
          </p>
        </div>
        <div className="bg-gray-50 p-4 md:p-6 rounded-lg" data-id="element-116">
          <div className="text-xl md:text-2xl mb-2" data-id="element-117">💊 Failed Solutions</div>
          <p className="text-sm md:text-base" data-id="element-118">
            Medications, compression socks, nothing really works
          </p>
        </div>
      </div>
      <p className="text-base md:text-lg text-center mb-6 md:mb-8" data-id="element-119">
        Sound familiar? You're not alone, and it's NOT your fault.
      </p>
    </section>;
}